export default __webpack_public_path__ + "static/Product-Disclosure-Sheet_EGTB_MY-e8ff1e9a0e26e03667f7370d80ef84ea.pdf";